import * as React from "react";
import { ControlButtons } from "../ControlButtons/ControlButtons";
import { Translation, ImagesData } from "../../../models/models";
import { RES_URL } from "../../../config";

export interface ImageContentProps {
  className?: string;
  item?: ImagesData;
  onPrevClick?: () => void;
  onNextClick?: () => void;
  currentIndex?: number;
  isLastPage?: boolean;
  isFirstPage?: boolean;
  locale?: Translation;

  //onFullscrenClick: (p: ImageContentProps) => void;
}

export interface ImageContentState {
  width: number;
  isMoving: boolean;
  viewWidth: number;
  height: number;
  viewHeight: number;
  isLoaded: boolean;
}
declare var jQuery;
export class ImageContent extends React.Component<
  ImageContentProps,
  ImageContentState
> {
  el: HTMLDivElement;
  imgOriginalEl: HTMLImageElement;
  imgTopEl: HTMLImageElement;

  constructor(p: ImageContentProps) {
    super(p);
    this.state = {
      isMoving: false,
      width: 0,
      viewWidth: 0,
      height: 0,
      viewHeight: 0,
      isLoaded: false
    };
  }

  componentDidMount() {
    setTimeout(() => {
      if (this.imgOriginalEl) {
        
        this.setState({
          width: this.imgOriginalEl.getBoundingClientRect().width,
          height: this.imgOriginalEl.getBoundingClientRect().height,
          viewWidth: this.imgOriginalEl.getBoundingClientRect().width / 2,
          isLoaded: true
        });
      }
    }, 200);

    window.addEventListener("resize", this.resize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resize);
  }

  resize = () => {
    this.setState({
      width: this.imgOriginalEl.getBoundingClientRect().width,
      height: this.imgOriginalEl.getBoundingClientRect().height
    });
  };

  enableWidthChange = () => {
    if (this.state.isMoving) return;
    this.setState({
      isMoving: true
    });
  };

  disableWidthChange = (event: React.MouseEvent<any>) => {
    let viewWidth =
      this.state.width -
      (event.clientX - this.imgOriginalEl.getBoundingClientRect().left);

    if (viewWidth < 0) {
      viewWidth = 0;
    }
    if (viewWidth > this.state.width) {
      viewWidth = this.state.width;
    }

    this.setState({
      isMoving: false,
      viewWidth
    });
  };

  freezeWidth = () => {
    this.setState({
      isMoving: false,
      viewWidth: this.state.width / 2
    });
  };

  setWidth = (event: React.MouseEvent<any>) => {
    if (this.state.isMoving) {
      let viewWidth =
        this.state.width -
        (event.clientX - this.imgOriginalEl.getBoundingClientRect().left);

      let viewHeight =
        this.state.height -
        (event.clientY - this.imgOriginalEl.getBoundingClientRect().left);

      if (viewHeight < 0) {
        viewHeight = 0;
      }

      if (viewHeight > this.state.height) {
        viewHeight = this.state.height;
      }

      if (viewWidth < 0) {
        viewWidth = 0;
      }
      if (viewWidth > this.state.width) {
        viewWidth = this.state.width;
      }
      this.setState({
        viewWidth,
        viewHeight
      });
    }
  };

  // imageClicked = () => {

  // }

  handleTouchMove = event => {
    if (this.state.isMoving) {
      let xPos = event.touches[0].clientX;
      let viewWidth =
        this.state.width -
        (xPos - this.imgOriginalEl.getBoundingClientRect().left);
      if (viewWidth < 0) {
        viewWidth = 0;
      }
      if (viewWidth > this.state.width) {
        viewWidth = this.state.width;
      }
      this.setState({
        viewWidth
      });
    }
  };

  changeMobileWidth = (event: React.TouchEvent) => {
    let xPos = event.touches[0].clientX;

    this.setState({
      isMoving: true,
      viewWidth:
        this.state.width -
        (xPos - this.imgOriginalEl.getBoundingClientRect().left)
    });
  };

 

  render() {
    let props = this.props,
      state = this.state,
      cls = this.props.className || "";

    
    return (
      <div className={"image-content " + cls} ref={e => (this.el = e)}>
        <div
          className="image-content__images"
          // onMouseOver={this.enableWidthChange}
          // onMouseLeave={this.disableWidthChange}
          onMouseDown={this.enableWidthChange}
          onMouseUp={this.disableWidthChange}
          onMouseMove={this.setWidth}
          onTouchStart={this.changeMobileWidth}
          onTouchMove={this.handleTouchMove}
          onTouchEnd={this.freezeWidth}
        >
          {/* <div className="image-content__full-screen" onClick={this.props.openFullScreen}><i className="icon-ip-ccicon-fullscreen"/></div> */}
          <div className="image-content__original">
            <img
              ref={e => (this.imgOriginalEl = e)}
              //onLoad={this.handleImageLoaded}
              src={`${RES_URL}img/photos/${props.item.imgSrc}`}
              alt=""
              className="original-img"
            />
          </div>
          <div
            className="image-content__top  animated fadeIn delay-5 speed-4"
            style={{ width: this.state.viewWidth + "px" }}
          >
            <img
              id="test"
              style={{ width: state.width + "px" }}
              ref={e => (this.imgTopEl = e)}
              src={`${RES_URL}img/photos/${props.item.imgSrcChanged}`}
              alt=""
              className="original-img"
            />
          </div>
          <div
            className="image-content__bar animated fadeIn delay-5 speed-4"
            style={{
              right: state.viewWidth + "px"
            }}
          >
            <div
              className="image-content__bar-icon"
              // onClick={() => {
              //   this.props.onFullscrenClick(this.props);
              // }}
            >
              <i className="icon-ip-ccicon-slider" />
            </div>
          </div>
        </div>
        <div className="image-content__text">
          <p>{this.props.item.label}</p>
        </div>

        <ControlButtons
          currentIndex={this.props.currentIndex}
          onNextClick={this.props.onNextClick}
          onPrevClick={this.props.onPrevClick}
          isFirstPage={this.props.isFirstPage}
          isLastPage={this.props.isLastPage}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ui/ImageContent/ImageContent.tsx